import { createApp } from 'vue'
import App from './App.vue'
import router from "./router"
import './assets/style/index.css'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import axios from "axios";
import VueAxios from "vue-axios";
//路由
createApp(App).use(router).use(ElementPlus).use(VueAxios,axios).mount('#app')
